import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { OrganisationCustomSettingsComponent } from './organisation-custom-settings.component';
import { AutoCompleteModule } from 'primeng/autocomplete';

const routes: Routes = [
  {
    path: '',
    component: OrganisationCustomSettingsComponent,
    data: { title: 'Organisation Settings' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrganisationCustomSettingsRoutingModule {}

@NgModule({
  imports: [
    OrganisationCustomSettingsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    AutoCompleteModule,
  ],
  declarations: [OrganisationCustomSettingsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OrganisationCustomSettingsModule {}
